import { useFormState } from "react-hook-form";
import { SaveButton, Toolbar } from "react-admin";
import * as React from "react";

const SkillEditorToolbar = (props) => {
  const { isValid } = useFormState();

  return (
    <Toolbar {...props}>
      <SaveButton disabled={!isValid} />
    </Toolbar>
  );
};

export default SkillEditorToolbar;
